import * as m from "./../../../dist/es2015/plugins/colorPicker.js";
export const am5plugins_colorPicker = m;